import groq from 'groq';

import { ASSET } from './asset';
import { CONSENT_CAPTURE } from './consentCapture';
import { OVERLINE } from './overline';
import { RICH_TEXT } from './richText';

export const PROMO_HERO_V2 = groq`
  hero {
    media {
      ${ASSET},
      hotspot,
      crop
    },
    productCutout {
      ${ASSET},
      hotspot,
      crop
    },
    credentialsOverlayImage {
      ${ASSET},
      hotspot,
      crop
    },
    credentialsIcons[] {
      _key,
      label,
      asset -> {
        url
      }
    },
    credentialsBullets[] {
      ${RICH_TEXT}
    },
    ${OVERLINE},
    "isDoctorRecommended": coalesce(isDoctorRecommended, false),
    text[] {
      ${RICH_TEXT}
    },
    cta {
      type,
      ${CONSENT_CAPTURE},
      link {
        href,
        title,
      },
      klaviyoListId,
    }
  }
`;
